import React, { memo, useCallback } from "react";
import TruncatedCell from "../../../../shared/components/Table/TruncatedCell";

/**
 * RateReviewTableBody Component
 */
const RateReviewTableBody = memo(({ leads = [], headers = [], onLeadClick, canEdit = true }) => {
  const handleLeadClick = useCallback((lead) => {
    if (document.activeElement) {
      document.activeElement.blur();
    }
    
    onLeadClick?.(lead);
  }, [onLeadClick]);

  if (leads.length === 0) {
    return (
      <tbody className="empty-table-body">
        <tr>
          <td colSpan={headers.length} className="text-center py-5 empty-state-cell">
            <div className="empty-state-content">
              <div className="empty-state-icon">📋</div>
              <div className="empty-state-text">No records found</div>
              <div className="empty-state-subtext">Try adjusting your filters or search criteria</div>
            </div>
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {leads.map((lead, index) => {
        return (
          <tr 
            key={`lead-${lead.id || lead.businessName || index}`}
            className="clickable-row"
            onClick={(e) => {
              e.preventDefault();
              handleLeadClick(lead);
            }}
            style={{ cursor: "pointer" }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleLeadClick(lead);
              }
            }}
          >
            <TruncatedCell 
              className="business-name-cell" 
              style={{ verticalAlign: 'middle' }}
              defaultTooltip="Click to view full details"
            >
              <span className="business-name-text">
                {lead.businessName}
              </span>
            </TruncatedCell>

            <TruncatedCell defaultTooltip="Click to view full details">
              {lead.contactName}
            </TruncatedCell>

            <TruncatedCell defaultTooltip="Click to view full details">
              {lead.email}
            </TruncatedCell>

            <TruncatedCell defaultTooltip="Click to view full details">
              {lead.phone}
            </TruncatedCell>

            <TruncatedCell defaultTooltip="Click to view full details">
              {lead.gatewayId || lead.Gateway_ID || "-"}
            </TruncatedCell>

            <TruncatedCell defaultTooltip="Click to view full details">
              {lead.dateCreated || ""}
            </TruncatedCell>

            {/* Status Badge */}
            <TruncatedCell defaultTooltip="Click to view full details">
              <span className={`badge cBadge ${lead.statusClass}`}>
                {lead.status}
              </span>
            </TruncatedCell>

          </tr>
        );
      })}
    </tbody>
  );
});

RateReviewTableBody.displayName = "RateReviewTableBody";

export default RateReviewTableBody;

